export class DateUtils {
  static calculateAge(date: string | Date, toDate?: string | Date) {
    const birthDate = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(birthDate.getTime())) {
      throw new Error('Invalid date provided');
    }

    let newToDate = new Date();
    if (toDate) {
      newToDate = typeof toDate === 'string' ? new Date(toDate) : toDate;
    }

    let age = newToDate.getFullYear() - birthDate.getFullYear();

    const monthDiff = newToDate.getMonth() - birthDate.getMonth();
    const dayDiff = newToDate.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  }
  static countDays(
    departureDate: Date | string,
    returnDate: Date | string
  ): number {
    const start = new Date(departureDate);
    const end = new Date(returnDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return null;
    }

    const diffTime = Math.abs(end.getTime() - start.getTime());

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }
}
